export default "__VITE_ASSET__DXNkwUj5__"